import type { ReactElement } from 'react';
import Card from './Card';
import { StepProvider } from '../Fundamentals/Stepper/StepContext';
import { StepBody, StepFooter, StepHeader, StepHeaderType } from '../Fundamentals/Stepper/Step';
import Spinner from '../Fundamentals/Spinner/Spinner';

interface StepperCardProps {
    title?: string;
    isStepLoading?: boolean;
    stepHeaderType?: number;
    allowBack?: boolean;
    children: ReactElement | ReactElement[];
}

export const StepperCard = ({ title, isStepLoading = false, stepHeaderType = StepHeaderType.HORIZONTAL, allowBack = false, children }: StepperCardProps) => {
    const steps = Array.isArray(children) ? children : [children];

    return (
        <Card>
            <StepProvider steps={steps}>
                {title !== undefined && (
                    <Card.CHeader>
                        <Card.Header.Title>{title}</Card.Header.Title>
                    </Card.CHeader>
                )}
                <Card.Content>
                    {stepHeaderType !== StepHeaderType.NONE && (
                        // the step labels reach past the stepper's edges; a titled card already clips them through its collapsible header
                        <div className={title === undefined ? 'px-40 overflow-x-hidden' : undefined}>
                            <StepHeader type={stepHeaderType} allowBack={allowBack} />
                        </div>
                    )}
                    {isStepLoading ? <Spinner /> : <StepBody />}
                </Card.Content>
                <Card.Footer>
                    <div className="w-100 pb-16">{!isStepLoading && <StepFooter />}</div>
                </Card.Footer>
            </StepProvider>
        </Card>
    );
};
